// TODO:  Do we need a AsPopUp type of confirmation???
import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';

import Button, {ButtonProps} from '@mui/material/Button';

import {IconButtonProps} from '@mui/material/IconButton';
import MuiIconButton from '@mui/material/IconButton';

const styles = (theme:Theme):StyleRules => ({
  container: {
    width: "100%" 
  },
  root: {
    color: 'white'
  },
  buttonStyle:{
    // raised: true,
    // minWidth: 120
  },
  buttonText:{
    paddingLeft: 5
  }
})

interface Props extends ButtonProps{
    title: string;
    confirmMessage: string;
    confirmColor?: "inherit" | "primary" | "secondary" | undefined
    confirmDelay?: any;
    onButtonConfirm: (evt: any) => void;
    onButtonClick?: (evt: any) => void;
    buttonIcon?: any;
    confirmIcon?: any;
    buttonStyle?: any;
    raised?: boolean;
    color?: "inherit" | "primary" | "secondary" | undefined
    disabled?: boolean;
};

interface IconProps extends IconButtonProps{
  confirmColor?: "inherit" | "primary" | "secondary" | undefined
  confirmDelay?: any;
  onButtonConfirm: (evt: any) => void;
  onButtonClick?: (evt: any) => void;
  confirmIcon?: any;
  color?: "inherit" | "primary" | "secondary" | undefined
  mini?: boolean
  disabled?: boolean
  size?: "small" | "medium" | "large"
};

type State = {
  title?: string;
  defaultTitle?: string;
  confirmMessage?: string;
  confirmTimeout: any;
};

export class IconButton extends React.Component<IconProps & WithStyles<keyof typeof styles>, State> {
  constructor(props:Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {confirmTimeout:0}
  }
  render(){
    return (
      <MuiIconButton 
        size={this.props.size || "small"}
        id={this.props.id} 
        className={this.props.className} 
        tabIndex={this.props.tabIndex || 0} 
        disabled={this.props.disabled} 
        onClick={this._onButtonClick} 
        style={{ color: this.state.confirmTimeout == 0 ? undefined : this.props.confirmColor == 'danger' ? 'red' : undefined}} 
        color={this.state.confirmTimeout == 0 ? this.props.color : (this.props.confirmColor == "danger" ? this.props.color : this.props.confirmColor || this.props.color)}
      >
        {this.state.confirmTimeout == 0 && this.props.children}
        {this.state.confirmTimeout != 0 && (this.props.confirmIcon || this.props.children)}
      </MuiIconButton>
    )
  }

  _onButtonClick = (event:any) => {
    if(this.state.confirmTimeout > 0){
      window.clearTimeout(this.state.confirmTimeout)
      this.setState({confirmTimeout: 0, defaultTitle: this.state.title || ''});
      this.props.onButtonConfirm(event)
    } else {
      var to = setTimeout( () =>{
        this.setState({confirmTimeout: 0, defaultTitle: this.state.title || ''});
      }
      ,  this.props.confirmDelay || 3000);
        this.setState({
          confirmTimeout: to, defaultTitle: this.state.confirmMessage || ''
        }, ()=>{
          if(this.props.onClick){
            this.props.onClick(event)
          }
        });
     
    }
  }
}



class ConfirmButton extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props:Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    
    this.state = {
      title: props.title,
      defaultTitle: props.title,
      confirmMessage: props.confirmMessage || "Confirm",
      confirmTimeout: 0

    }; 
  }
 componentDidMount(){
  }

  UNSAFE_componentWillReceiveProps(newProps:Props & WithStyles<keyof typeof styles>){
  }

  componentWillUnmount() {
    window.clearTimeout(this.state.confirmTimeout)
  }

  _onButtonClick = (event:any) => {
    if(this.state.confirmTimeout > 0){
      window.clearTimeout(this.state.confirmTimeout)
      this.setState({confirmTimeout: 0, defaultTitle: this.state.title || ''});
      this.props.onButtonConfirm(event)
    } else {
      var to = setTimeout( () =>{
        this.setState({confirmTimeout: 0, defaultTitle: this.state.title || ''});
      }
      ,  this.props.confirmDelay || 3000);
     
        this.setState({
          confirmTimeout: to, defaultTitle: this.state.confirmMessage || ''
        }, ()=>{
          if(this.props.onButtonClick){
            this.props.onButtonClick(event)
          }
        });
     
    }
  }


  render () {

    const { classes }: { classes:ClassNameMap } = this.props
    const { color, confirmColor, disabled } = this.props
      return (
        <Button
          id={this.props.id}
          variant={this.props.variant}
          size={this.props.size}
          className={classes.buttonStyle} 
          disabled={disabled}
          color={"inherit"}
          onClick={this._onButtonClick}
          style={this.props.buttonStyle}
        >
          {this.state.confirmTimeout == 0 ? (this.props.buttonIcon || "") : (this.props.confirmIcon || "")}
          <span className={classes.buttonText}>{this.state.defaultTitle}</span>
        </Button>
      );
  }
}
 

export default  withStyles(styles)(ConfirmButton);
